import { useI18n } from "@/i18n/I18nProvider";
import Box from "@mui/material/Box";
import { colors } from "../../utils/const";

export default function Header() {
  const { t, locale } = useI18n();
 
  return (
    <Box
      sx={{
        height: {
          xs: "360px",
          sm: "520px",
          md: "650px",
          lg: "800px",
          xl: "930px",
        },
      }}
      id="header-section"
    >
      <Box
        className="horizontal-safe-padding vertical-safe-padding"
        sx={{
          backgroundColor: colors.dark_blue,
          position: "relative",
          height: { xs: "250px", sm: "350px", md: "450px", lg: "650px" },
        }}
      >
        {/* HEADER TEXT */}
        <Box
          component="h1"
          sx={{
            fontSize: {
              xs: "20px",
              sm: "30px",
              md: "35px",
              lg: "52px",
            },
            textTransform: "uppercase",
            fontWeight: "700",
            letterSpacing: locale === "en" ? "1.04px" : "0",
            lineHeight: { xs: "1.8", sm: "1.6" },
            color: "white",
          }}
        >
          {t.pages_main_tags.whyContact.header.title}
        </Box>

        {/* VIDEO CONTAINER */}
        <Box
          className="horizontal-safe-padding vertical-safe-padding"
          sx={{
            width: "100%",
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          <video
            src={t.pages_main_tags.whyContact.header.video}
            width="100%"
            height="100%"
            autoPlay
            loop
            muted
            playsInline
            style={{
              objectFit: "cover",
              display: "block",
              borderRadius: "24px",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}
